var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeguro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.431 -0.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.294,20.369l-4.075-4.075L10,18.512l6.294,6.294L28.881,12.218,26.662,10Z",
    transform: "translate(5.734 5.734)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.881,46.055l-9.717-5.181A17.279,17.279,0,0,1,4,25.6V5.147A3.15,3.15,0,0,1,7.147,2H38.615a3.15,3.15,0,0,1,3.147,3.147V25.6A17.279,17.279,0,0,1,32.6,40.874ZM7.147,5.147V25.6a14.137,14.137,0,0,0,7.5,12.5l8.236,4.391L31.117,38.1a14.137,14.137,0,0,0,7.5-12.5V5.147Z",
    transform: "translate(2.294 1.147)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 50,
    transform: "translate(-0.431 0.349)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguro);
export default __webpack_public_path__ + "static/media/seguro.2ccf71aa43d520592dc5a41c8f3a0931.svg";
export { ForwardRef as ReactComponent };